module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h3', {
    staticClass: "h3"
  }, [_c('a', {
    attrs: {
      "id": "file_012"
    }
  }, [_vm._v("The Felting Needle")])]), _c('a', {
    attrs: {
      "id": "file_012"
    }
  }), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "file_012"
    }
  }, [_vm._v("There are three basic types of industrial felt. Woven felt is wool or a blend of wool and other yarn that is woven into a cloth and then felted using steam and pressure to make the fibers interlock. Pressed felt is the oldest type of fabric known, predating weaving and knitting, and is produced simply by pressing fibers together and steaming to naturally interlock the fibers. The third type of industrial felt, needled felt, is produced by a machine that carries thousands of felting needles and moves up and down to mechanically interlock fibers. The felting needle is a long, sharp, three- or five-sided barbed instrument. Sounds dangerous, eh? This needle ")]), _c('a', {
    attrs: {
      "id": "page_7"
    }
  }, [_vm._v("is the tool used for sculptural needle felting.")])]), _c('a', {
    attrs: {
      "id": "page_7"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Felting needles come in a variety of gauges from fine (forty gauge) to coarse (thirty-eight gauge) and they vary in the number of sides on the bottom shaft (three to five). The sides of the needle have tiny barbs poking out. Some of the barbs are close together and some are further apart. I recommend starting with a thirty-eight-gauge triangular (three-sided) needle. This size is considered standard.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The projects in this book only require using one needle at a time. There are needle holders available that can hold two to sixteen needles at a time. The needle holders have a handle that unscrews so you can put the needles in and remove them. This tool is good if you want to make a large sculpture or large flat piece of felt.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Store your needle in a safe place when you are not using it. I usually poke my needle deep into the side of a foam pad. Take care not to bend the needles. They are strong but brittle and they will break when bent. It goes without saying, try not to poke yourself while working. Watch your hands while you work.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3b6aa9ec","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/file_012.vue
// module id = 87
// module chunks = 0